import React, {useContext, useEffect, useState} from "react";
import AccountParam from "./AccountParam";
import SecurityParam from "./SecurityParam";
import NotificationParam from "./NotificationParam";
import Preferences from "./Preferences";
import {useDispatch, useSelector} from "react-redux";
import {isEmpty} from "../Utils";
import {Redirect} from "react-router-dom";
import LanguageParam from "./LanguageParam";
import {MyContext} from "../../contexts/MyContext";
import { useHistory } from "react-router-dom";
import {useMediaQuery} from "react-responsive";
import SubscriptionParam from "./subscription/SubscriptionParam";
import {
	getActiveCustomerProduct,
	getCustomer,
	getInvoices,
	getListPaymentsMethods, getPaymentsIntents,
	getProducts
} from "../../actions/stripe.action";

const Parameters = () => {
	const translations = useSelector(
		(state) => state.langReducer.translationsReducer.translate
	);
	const dispatch = useDispatch();
	const history = useHistory();
	const { rootState } = useContext(MyContext);
	const { isAuth, redirect } = rootState;
	const [state, setState] = useState(null);
	const [actualComponent, setActualComponent] = useState(<AccountParam/>);
	const [actualComponentName, setActualComponentName] = useState("AccountParam");
	const isMobile = useMediaQuery({ query: "(max-width: 1000px)" });
	const settings = useSelector((state) => state.settingReducer.getSettingReducer.config);
	const stripeReducer = useSelector((state) => state.stripeReducer);
	const customer = stripeReducer.getCustomerReducer;

	useEffect(() => {
		if (!isEmpty(settings) && settings.subscription_features === "yes") {
			dispatch(getCustomer());
		}
	}, [dispatch, settings]);

	useEffect(() => {
		if ((customer.id && customer?.deleted !== true) && !isEmpty(settings) && settings.subscription_features === "yes") {
			dispatch(getListPaymentsMethods(customer.id));
			dispatch(getInvoices(customer.id));
			dispatch(getPaymentsIntents(customer.id));
			dispatch(getProducts(1));
			let timeout = setTimeout(() => {
				dispatch(getActiveCustomerProduct())
			}, 2000);
			return () => clearTimeout(timeout);
		}
	}, [customer, dispatch, settings])

	useEffect(() => {
		async function auth() {
			if (isAuth) {
				localStorage.removeItem('loginRedirectUrl');
			} else {
				localStorage.setItem('loginRedirectUrl', window.location);
			}
			if (redirect !== null) setState(!redirect);
		}
		auth();
	}, [isAuth, redirect]);

	const clickBack = () => {
		if (history.length > 2) {
			history.goBack();
		} else {
			history.push(`/discipline`);
		}
	};

	return (
		<div className="parameters-container">
			{isMobile && <Redirect to="/" />}
			{state === false && <Redirect to="/account/login" />}
			<div className="parameters-title">
				<div className="title" style={{background: !isEmpty(settings) ? settings.accent_color : ""}}>
					<h1>
						<span onClick={() => clickBack()}/>
						{translations && !isEmpty(translations["page_settings_settings"])
							? translations["page_settings_settings"]
							: "Settings"
						}
					</h1>
				</div>
				<svg height="3" fill="none" xmlns="http://www.w3.org/2000/svg">
					<rect width="20%" height="2" fill="#1B3FFF"/>
					<rect x="20%" width="20%" height="2" fill="#D43D17"/>
					<rect x="40%" width="20%" height="2" fill="#4DAEC9"/>
					<rect x="60%" width="20%" height="2" fill="#ECC24A"/>
					<rect x="80%" width="20%" height="2" fill="#9AB94F"/>
				</svg>
			</div>

			<div className="parameters-content">
				<nav className="menu">
					<ul style={{background: !isEmpty(settings) ? settings.accent_color : ""}}>
						<li
							className={actualComponentName === "AccountParam" ? "selected" : null}
							onClick={() => {
								setActualComponent(<AccountParam/>)
								setActualComponentName("AccountParam");
							}}
						>
							<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M6.29406 16.9029V14.1427C6.29405 13.4433 6.89274 12.8751 7.63431 12.8707H10.3572C11.1021 12.8707 11.7059 13.4402 11.7059 14.1427V16.8949C11.7059 17.5016 12.2249 17.9946 12.868 17.999H14.7257C15.5933 18.0011 16.4262 17.6775 17.0405 17.0997C17.6548 16.5218 18 15.7371 18 14.9188V7.07828C18 6.41727 17.6893 5.79026 17.1517 5.36617L10.8407 0.605865C9.73754 -0.226766 8.16193 -0.199869 7.09142 0.669869L0.916117 5.36617C0.353123 5.77776 0.0166285 6.40663 0 7.07828V14.9108C0 16.6164 1.46594 17.999 3.27427 17.999H5.08954C5.39922 18.0011 5.69699 17.8866 5.91676 17.6808C6.13654 17.475 6.26014 17.195 6.26013 16.9029H6.29406Z" fill="white"/>
							</svg>

							<span>
							{translations && !isEmpty(translations["account"])
								? translations["account"]
								: "Votre profil"
							}
						</span>
						</li>
						<li
							className={actualComponentName === "Preferences" ? "selected" : null}
							onClick={() => {
								setActualComponent(<Preferences/>)
								setActualComponentName("Preferences");
							}}
						>
							<svg width="22" height="17" viewBox="0 0 22 17" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M3.20065 16.7354H18.3591C20.2551 16.7354 21.3721 15.6278 21.3721 13.5535V3.17249C21.3721 1.10756 20.2551 0 18.1714 0H3.01293C1.11694 0 0 1.10756 0 3.17249V13.5535C0 15.6278 1.11694 16.7354 3.20065 16.7354ZM9.67703 8.56948L3.05986 2.03678C3.12556 2.02739 3.19126 2.02739 3.25696 2.02739H18.1151C18.1902 2.02739 18.2559 2.02739 18.331 2.03678L11.7138 8.56948C11.329 8.94492 11.0286 9.10448 10.7001 9.10448C10.3622 9.10448 10.0619 8.94492 9.67703 8.56948ZM1.99923 3.49162L6.87999 8.29728L1.99923 13.1405V3.49162ZM14.5109 8.29728L19.3728 3.51039V13.1123L14.5109 8.29728ZM3.25696 14.708C3.15372 14.708 3.05986 14.6986 2.97538 14.6892L8.15649 9.55501L8.58825 9.97739C9.28282 10.6626 9.968 10.9629 10.7001 10.9629C11.4228 10.9629 12.108 10.6626 12.8026 9.97739L13.2344 9.54563L18.4155 14.6892C18.3216 14.6986 18.2184 14.708 18.1151 14.708H3.25696Z" fill="white"/>
							</svg>

							<span>
							{translations && !isEmpty(translations["register_email_ph"])
								? translations["register_email_ph"]
								: "Email"}
						</span>
						</li>
						<li
							className={actualComponentName === "SecurityParam" ? "selected" : null}
							onClick={() => {
								setActualComponent(<SecurityParam/>)
								setActualComponentName("SecurityParam");
							}}
						>
							<svg width="17" height="21" viewBox="0 0 17 21" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M2.70321 21H13.6301C15.4437 21 16.3333 20.1791 16.3333 18.3919V10.8169C16.3333 9.23751 15.6148 8.40623 14.1776 8.25037V5.90203C14.1776 1.93271 11.2349 0 8.16667 0C5.09846 0 2.15573 1.93271 2.15573 5.90203V8.25037C0.707169 8.40623 0 9.23751 0 10.8169V18.3919C0 20.1791 0.889665 21 2.70321 21ZM4.61941 5.72538C4.61941 3.44978 6.20484 2.1717 8.16667 2.1717C10.1285 2.1717 11.7139 3.44978 11.7139 5.72538V8.2192H4.61941V5.72538ZM3.28492 18.8699C2.80587 18.8699 2.56634 18.662 2.56634 18.1321V11.0767C2.56634 10.5468 2.80587 10.3597 3.28492 10.3597H13.0484C13.5389 10.3597 13.767 10.5468 13.767 11.0767V18.1321C13.767 18.662 13.5389 18.8699 13.0484 18.8699H3.28492Z" fill="white"/>
							</svg>

							<span>
							{translations && !isEmpty(translations["register_password_ph"])
								? translations["register_password_ph"]
								: "Password"
							}
						</span>
						</li>
						<li
							className={actualComponentName === "LanguageParam" ? "selected" : null}
							onClick={() => {
								setActualComponent(<LanguageParam/>)
								setActualComponentName("LanguageParam");
							}}
						>
							<svg width="25" height="19" viewBox="0 0 25 19" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M24.6909 10.3082C23.9109 8.23312 21.7334 6.99436 18.8647 6.99436C18.7522 6.99436 18.6447 6.99679 18.5372 7.00166L18.5172 4.49376C18.5172 4.49376 22.7796 3.77895 22.9234 3.75585C23.0671 3.73275 23.0896 3.61119 23.0596 3.47504C23.0309 3.3401 22.8509 2.40161 22.8246 2.28855C22.7909 2.1293 22.6971 2.13416 22.5659 2.15605C22.4359 2.17793 18.5034 2.71646 18.5034 2.71646C18.5034 2.71646 18.4884 0.342285 18.4872 0.190328C18.4859 0.0383711 18.4009 -0.00174596 18.2447 0.000582712C18.0884 0.0031167 17.0947 0.0177042 16.9635 0.0201356C16.8322 0.0225669 16.7585 0.0797027 16.761 0.200053C16.7635 0.321618 16.8022 3.00458 16.8022 3.00458C16.8022 3.00458 12.976 3.64523 12.8722 3.66468C12.7672 3.6817 12.6597 3.72911 12.6835 3.83852C12.7072 3.94792 12.921 5.16844 12.9435 5.26327C12.966 5.36052 13.0335 5.42009 13.1785 5.39334C13.3222 5.37024 16.8335 4.78065 16.8335 4.78065L16.8772 7.23385C15.531 7.57545 14.626 8.23555 14.0572 8.81785C13.0972 9.79888 12.5485 11.1118 12.5485 12.4198C12.5485 14.3479 13.7622 15.4942 15.4585 15.696C19.4109 16.1665 21.8571 11.9761 22.6696 9.96421C24.0409 11.795 22.9896 15.2572 20.0522 17.2338C19.9984 17.2691 19.9297 17.3907 20.0109 17.4855C20.0922 17.5803 20.6872 18.2903 20.7847 18.4045C20.8847 18.5212 21.0422 18.4762 21.1047 18.4325C24.2421 16.3294 25.6809 12.9438 24.6909 10.3082ZM15.4585 14.1838C14.251 14.0367 14.2785 13.0726 14.2785 12.4174C14.2785 11.4777 14.6872 10.4967 15.3735 9.79645C15.7922 9.36611 16.311 9.04153 16.9097 8.82514L17.0122 14.0245C16.531 14.1838 16.0135 14.2494 15.4585 14.1838ZM18.4922 13.5115L18.5497 8.51637C18.6547 8.5115 18.7572 8.50421 18.8647 8.50421C19.8309 8.50421 20.7322 8.68048 21.2209 8.94306C21.7096 9.20686 19.9422 12.2411 18.4922 13.5115ZM7.30481 4.18984C7.26731 4.07557 7.17606 4.01357 7.05981 4.01357H4.62234C4.50609 4.01357 4.41609 4.07557 4.37984 4.18862C3.86485 5.76776 0.0298922 17.5487 0.00989241 17.6107C-0.0113573 17.6727 -0.00385744 17.7031 0.0873915 17.7031H2.25362C2.34737 17.7031 2.37737 17.6751 2.39612 17.6156C2.41487 17.5536 3.6561 13.582 3.6561 13.582H8.02605C8.02605 13.582 9.26604 17.5548 9.28604 17.6156C9.30604 17.6751 9.33479 17.7031 9.42729 17.7031H11.5948C11.6848 17.7031 11.6923 17.6727 11.6723 17.6107C11.6548 17.5499 7.81855 5.76898 7.30481 4.18984ZM4.03235 11.8704L5.84108 5.48816L7.64981 11.8704H4.03235Z" fill="white"/>
							</svg>

							<span>
								{translations && !isEmpty(translations["languages"])
									? translations["languages"]
									: "Languages"
								}
							</span>
						</li>
						<li
							className={actualComponentName === "NotificationParam" ? "selected" : null}
							onClick={() => {
								setActualComponent(<NotificationParam/>);
								setActualComponentName("NotificationParam");
							}}
						>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="24"
								height="24"
								viewBox="0 0 24 24"
							>
								<path d="M15.137 3.945c-.644-.374-1.042-1.07-1.041-1.82v-.003c.001-1.172-.938-2.122-2.096-2.122s-2.097.95-2.097 2.122v.003c.001.751-.396 1.446-1.041 1.82-4.667 2.712-1.985 11.715-6.862 13.306v1.749h20v-1.749c-4.877-1.591-2.195-10.594-6.863-13.306zm-3.137-2.945c.552 0 1 .449 1 1 0 .552-.448 1-1 1s-1-.448-1-1c0-.551.448-1 1-1zm3 20c0 1.598-1.392 3-2.971 3s-3.029-1.402-3.029-3h6z" />
							</svg>
							<span>
								{translations && !isEmpty(translations["notifications"])
									? translations["notifications"]
									: "Notifications"
								}
							</span>
						</li>
						{!isEmpty(settings) && settings.subscription_features === "yes" && (
							<li
								className={actualComponentName === "SubscriptionParam" ? "selected" : null}
								onClick={() => {
									setActualComponent(<SubscriptionParam/>);
									setActualComponentName("SubscriptionParam");
								}}
							>
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M8.5 9.00006H10.5C10.7761 9.00006 11 8.77618 11 8.50006C11 8.22393 10.7761 8.00006 10.5 8.00006H8.5C8.22388 8.00006 8 8.22393 8 8.50006C8 8.77618 8.22388 9.00006 8.5 9.00006ZM12.5 16.0001H6.5C6.22388 16.0001 6 16.2239 6 16.5001C6 16.7762 6.22388 17.0001 6.5 17.0001H12.5C12.7761 17.0001 13 16.7762 13 16.5001C13 16.2239 12.7761 16.0001 12.5 16.0001ZM12.5 12.0001H6.5C6.22388 12.0001 6 12.2239 6 12.5001C6 12.7762 6.22388 13.0001 6.5 13.0001H12.5C12.7761 13.0001 13 12.7762 13 12.5001C13 12.2239 12.7761 12.0001 12.5 12.0001ZM21.5 12.0001H17V2.50006C17.0001 2.41253 16.9771 2.32653 16.9335 2.25067C16.7959 2.01135 16.4904 1.92889 16.251 2.06646L13 3.92974L9.74902 2.06646C9.5946 1.97857 9.4054 1.97857 9.25098 2.06646L6 3.92974L2.74902 2.06646C2.67316 2.02282 2.58716 1.99994 2.49963 1.99994C2.22357 2.00012 1.99988 2.224 2 2.50006V19.5001C2.00128 20.8802 3.11981 21.9988 4.5 22.0001H18.5C18.5594 22.0001 18.6147 21.9853 18.6676 21.9662C18.7782 21.9787 18.8861 21.9999 19 22.0001C20.6561 21.9982 21.9982 20.6562 22 19.0001V12.5001C22 12.4999 22 12.4997 22 12.4994C21.9998 12.2235 21.776 11.9999 21.5 12.0001ZM4.5 21.0001C3.67194 20.9991 3.00092 20.3281 3 19.5001V3.36236L5.74121 4.93365C5.90253 5.02154 6.09747 5.02154 6.25879 4.93365L9.5 3.07623L12.7412 4.93365C12.9025 5.02154 13.0975 5.02154 13.2588 4.93365L16 3.36236V12.5001V13.5001V19.0001C16.0009 19.772 16.3011 20.4685 16.7803 21.0001H4.5ZM21 19.0001C21 20.1046 20.1046 21.0001 19 21.0001C17.8954 21.0001 17 20.1046 17 19.0001V13.5001V13.0001H21V19.0001Z" fill="#ffff"/>
								</svg>
								<span>
									{translations && !isEmpty(translations["subscription"])
										? translations["subscription"]
										: "Subscription"
									}
								</span>
							</li>
						)}
					</ul>
				</nav>
				{actualComponent}
			</div>

		</div>
	);
};

export default Parameters;
